<template>
  <v-responsive :aspect-ratio="16/9">
    <slot v-if="!loadPlayer"></slot>
    <div style="width: 100%; height: 100%; display: flex; align-items: center; justify-content: center;" v-if="!started && loadPlayer" @click="play"><v-btn icon><v-icon x-large>play_arrow</v-icon></v-btn></div>
    <div v-if="started" style="width: 100%; height: 100%; display: flex;" ref="player_container" class="player_container">
      <video style="width: 100%; height: 100%; object-fit: contain;" id="video" preload="false" ref="player"></video>
      <v-system-bar window dark style="background-color: rgba(0,0,0,.5) !important; position: absolute; bottom: 0px; left: 0px; width: 100%; z-index: 10000;" :class="{'hide-bar': !show_bar}">
        <v-btn icon style="margin: 0; padding: 0;" small @click="play_toggle"><v-icon style="margin-right: 0;">{{play_icon}}</v-icon></v-btn>
        <v-spacer></v-spacer>
        <v-btn icon style="margin: 0; padding: 0;" small @click="mute_toggle"><v-icon style="margin-right: 0;">{{volume_icon}}</v-icon></v-btn>
        <div :style="{width: (fullscreen ? '120px' : '60px')}" style="margin-right: 8px; margin-left: 8px;"><v-slider v-model="volume" hide-details style="margin-top: 0;" thumb-color="white" :min="0.0" :max="1.0" :step="0.0001"></v-slider></div>
        <v-btn icon style="margin: 0; padding: 0;" small @click="fullscreen_toggle"><v-icon style="margin-right: 0;">{{fullscreen_icon}}</v-icon></v-btn>
      </v-system-bar>
    </div>
  </v-responsive>
</template>
<script>
  import screenfull from './screenfull.js'
  import Hls from 'hls.js'
  export default {
    props: ["load-player", "url", "autoplay"],
    data () {
      return {
        video: undefined,
        hls: undefined,
        started: false,
        playing: false,
        muted: false,
        volume: 0.0,
        fullscreen: false,
        show_bar: true,
      }
    },
    watch: {
      volume(newVal) {
        if(this.video) this.video.volume = newVal;
      },
      url(newVal) {
        if (this.video) {
          if (typeof(this.hls) != "undefined") {
            this.hls.loadSource(newVal);
          } else {
            this.video.src = newVal;
          }
        }
      }
    },
    computed: {
      play_icon() {
        if(this.playing) return "pause";
        return "play_arrow";
      },
      volume_icon() {
        if(this.muted || this.volume == 0) return "volume_off";
        if(this.volume < 0.5) return "volume_down";
        return "volume_up";
      },
      fullscreen_icon() {
        if(this.fullscreen) return "fullscreen_exit";
        return "fullscreen";
      }
    },
    methods: {
      fullscreenchanged() {
        if (screenfull.isFullscreen) {
          this.fullscreen = true;
        } else {
          this.fullscreen = false;
        }
      },
      fullscreen_toggle() {
        if(!this.video) return;
        var player = this.$refs.player_container
        if (screenfull.isEnabled) {
          screenfull.toggle(player);
        }
      },
      play_toggle() {
        if(!this.video) return;
        if(this.playing) {
          this.video.pause();
        }
        if(!this.playing) {
          this.video.play();
        }
      },
      mute_toggle() {
        if(!this.video) return;
        this.video.muted = !this.video.muted;
        this.muted = this.video.muted;
      },
      play() {
        var self = this;
        this.started = true;
        this.$nextTick(() => {
          var autoplay = this.autoplay;
          this.video = this.$refs.player;
          if (Hls.isSupported()) {
            this.hls = new Hls({
              debug: false
            });
            this.hls.loadSource(this.url);
            this.hls.attachMedia(this.video);
            this.hls.on(Hls.Events.MEDIA_ATTACHED, () => {
              this.video.volume = 0.0001;
              this.video.play();
            });
            this.video.addEventListener("volumechange", (event) => {
              this.volume = this.video.volume;
            });
            this.video.addEventListener("play", (event) => {
              this.playing = true;
              this.show_bar = false;
            })
            this.video.addEventListener("pause", (event) => {
              this.playing = false;
              this.show_bar = true;
            })
            this.video.addEventListener("playing", (event) => {
              this.$emit("input", {
                width: this.video.videoWidth,
                height: this.video.videoHeight
              })
            })
          }
          else if (this.video.canPlayType('application/vnd.apple.mpegurl')) {
            this.video.src = this.url;
            this.video.addEventListener('canplay', () => {
              this.video.play();
            });
          }
        })

      }
    },
    mounted() {
      if (screenfull.isEnabled) {
        screenfull.on('change', this.fullscreenchanged);
      }
    },
    beforeDestroy() {
      if(this.hls) this.hls.destroy();
    }
  }
</script>
<style scoped>
.hide-bar {
  transition: opacity 0.2s ease-out;
  opacity: 0;
}
.player_container:hover .hide-bar {
  opacity: 1;
}
</style>
<style>
  /* Safari syntax */
  :-webkit-full-screen {
    background-color: black;
  }

  /* IE11 */
  :-ms-fullscreen {
    background-color: black;
  }

  /* Standard syntax */
  :fullscreen {
    background-color: black;
  }
</style>